import { all } from 'redux-saga/effects';

import catalogsSaga from './catalogs';
import settingsSaga from './settings';

export default function* rootSaga() {
  yield all([settingsSaga(), catalogsSaga()]);
}
